import sdk from './sdk';
import config from './config';

/**
 *  带链接富文本消息体转换
 */

// 是否为带链接富文本消息体
var isNeedConvert = function (content) {
  if (!content || !content.extra) {
    return false;
  }

  try {
    var extrainfo = content.extra;
    if (typeof (content.extra) === 'string') {
      extrainfo = JSON.parse(content.extra);
    }
    if (!extrainfo.richtext_format) {
      return false;
    }

    var flag = true;
    if (content && content.extra) {
      var richtext_format = extrainfo.richtext_format;
      var richtext = richtext_format.richtext;
      var format = richtext_format.format;
      // 对于富文本格式传入不正确的，不处理
      if (!richtext || !format || richtext === '' || format.length === 0) {
        flag = false;
      }
    } else {
      // 对不符合富文本格式的内容，直接返回
      flag = false;
    }
    return flag;
  } catch (e) {
    return false;
  }
};

var _format = function (richtext, foramt, contact) {
  var _me = sdk.get().me();
  richtext = richtext.replace(/\{\d{1,}\}/g, function (item) {
    var num = item.toString().split('{')[1].split('}')[0];
    if (num > foramt.length - 1) {
      return item;
    }
    var url = foramt[num].url ? foramt[num].url : '';
    var color = foramt[num].color ? foramt[num].color.toString() : 'blue';
    var font_weight = foramt[num].bold && foramt[num].bold.toString() === '1' ? 'bold' : 'normal';
    var action_code = foramt[num].action_code ? foramt[num].action_code.toString() : '';
    var rich_text, params, _baseUrl, xz_source;

    // 不同跳转方式
    switch (action_code) {
      case '1005':
      case '1002':
        // 通用不跳转
        url = 'javascript:void(0)';
        break;
      case '1003':
        // 信息质量控制-申诉
        _baseUrl = 'https://about.58.com/appeal/weiliao/m';
        xz_source = config.get('xz-source') + '';
        params = {
          'sceneid': '97',
          'userid': _me.user_id,
          'appealerid': _me.user_id,
          'appealobjid': _me.user_id,
          'appealobjtype': '2',
          'appealtermsource': xz_source,
          'appealsource': xz_source
        };
        url = _baseUrl + '?bizjson=' + JSON.stringify(params) + '&backurl=' + encodeURIComponent(window.location.href);
        break;
      case '1004':
        // 信息质量控制-投诉
        xz_source = config.get('xz-source') + '';
        _baseUrl = 'https://about.58.com/vote/weiliao/m';
        params = {
          'sceneid': '94',
          'userid': _me.user_id,
          'voterid': _me.user_id,
          'accusedid': contact.user_id,
          'accusedobjid': contact.user_id,
          'accusedobjtype': '2',
          'votetermsource': xz_source,
          'votesource': xz_source,
          'accusedsource': contact.user_source
        };
        url = _baseUrl + '?bizjson=' + JSON.stringify(params) + '&backurl=' + encodeURIComponent(window.location.href);
        break;
      case '1001':
        // 通用跳转
        break;
      default:
        break;
    }
    if (action_code === '1005') {
      rich_text = '<span>' + foramt[num].linktext + '</span>';
    } else {
      var dom_a = document.createElement('a');
      dom_a.style.margin = '0 .05rem';
      dom_a.style.textDecoration = 'none';
      dom_a.style.color = '#' + color;
      dom_a.style.fontWeight = font_weight;
      dom_a.style.targrt = '_blank';
      dom_a.href = url;
      dom_a.innerText = foramt[num].linktext;
      rich_text = dom_a.outerHTML;
      // rich_text = '<a href="' + url + '" style="margin: ;text-decoration:none;color:#' + color + ';font-weight:' + font_weight + '" target="_blank">' + foramt[num].linktext + '</a>';
    }
    return rich_text;
  });
  return richtext;
};

var richTextFormat = function (msg) {
  var content = msg.content;
  if (!isNeedConvert(content)) {
    return msg;
  }
  try {
    // 对文本进行富文本转换
    var extrainfo = JSON.parse(content.extra);
    var richtext_format = extrainfo.richtext_format;
    var richtext = richtext_format.richtext;
    var format = richtext_format.format;

    // 确认消息双方，便于信质使用
    var _me = sdk.get().me();
    var _contact = {};
    if (_me.user_id + '' === msg.to_id + '' && _me.user_source + '' === msg.to_source + '') {
      _contact.user_id = msg.sender_id;
      _contact.user_source = msg.sender_source;
    } else {
      _contact.user_id = msg.to_id;
      _contact.user_source = msg.to_source;
    }

    // 文本消息
    if (content.type.toString() === 'text') {
      content.msg = _format(richtext, format, _contact);
    } else if (content.type.toString() === 'tip') {
      content.text = _format(richtext, format, _contact);
    }
    return msg;
  } catch (e) {
    return msg;
  }
};

export { isNeedConvert, richTextFormat };

